import { render } from "./ListUsersComponent.vue?vue&type=template&id=ed9d1c64"
import script from "./ListUsersComponent.vue?vue&type=script&lang=js"
export * from "./ListUsersComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__